import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { contentTypeLabel, normalize } from '../utils/payloadFormat';
import HighlightedCode from './HighlightedCode';

interface PayloadViewProps {
  body?: string | null;
  maxHeight?: number;
}

const PayloadView: React.FC<PayloadViewProps> = ({ body, maxHeight }) => {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);

  const normalized = useMemo(() => normalize(body), [body]);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(normalized || body || '');
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      /* clipboard unavailable */
    }
  };

  if (!body) {
    return <div className="text-muted fst-italic p-2">{t('NoPayload')}</div>;
  }

  return (
    <div className="gg-payload-view border rounded">
      <div className="d-flex justify-content-between align-items-center p-2 border-bottom bg-light">
        <span className="badge bg-secondary">{contentTypeLabel(body)}</span>
        <button type="button" className="btn btn-sm btn-outline-primary" onClick={handleCopy}>
          <i className="bi bi-clipboard" /> {copied ? t('Copied') : t('Copy')}
        </button>
      </div>
      <div style={{ maxHeight, overflow: maxHeight ? 'auto' : undefined }} className="p-2 font-monospace small">
        <HighlightedCode text={normalized} />
      </div>
    </div>
  );
};

export default PayloadView;
